<template>
  <section class="apply-date">
    <h3 class="title">2024年二级建造师<b>报考时间</b>「自助查询」</h3>
    <div class="line"></div>
    <div class="content" style="width: 842px">
      <ul>
        <li :class="{ on: provinceIndex == index }" v-for="(item, index) in provinces" :key="index" @click="provinceIndex = index">
          {{ item }}
        </li>
      </ul>
      <p class="choose">
        已选择省份：<span>{{ provinces[provinceIndex] }}</span>
      </p>
      <div class="submit-box">
        <input type="text" placeholder="请输入您的手机号" v-model="mobile" />
        <button @click="onSubmit">查询结果</button>
      </div>
      <div class="bottom-hint"><span>注：</span>部分省份报名时间相比往年提前，请选择当地省份查询，及时关注考试动态</div>
    </div>
    <submit-success-dialog ref="successRef"></submit-success-dialog>
  </section>
</template>
<script>
import { Message } from 'element-ui'
import md5 from 'js-md5'
import SubmitSuccessDialog from './submit-success-dialog'
import { graduatePromot } from '@/api/index'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      provinceIndex: -1,
      provinces: [
        '北京',
        '山东',
        '江苏',
        '湖北',
        '湖南',
        '天津',
        '河北',
        '河南',
        '浙江',
        '内蒙古',
        '广东',
        '辽宁',
        '安徽',
        '上海',
        '黑龙江',
        '重庆',
        '海南',
        '贵州',
        '吉林',
        '江西',
        '甘肃',
        '陕西',
        '西藏',
        '宁夏',
        '四川',
        '山西',
        '福建',
        '青海',
        '广西',
        '其他'
      ],
      mobile: ''
    }
  },
  components: {
    SubmitSuccessDialog
  },
  methods: {
    onSubmit() {
      if (this.provinceIndex == -1) {
        return Message.error('请选择省份')
      }
      if (!this.mobile.length) {
        return Message.error('请输入手机号')
      }
      if (!phoneValidator(this.mobile)) {
        return Message.error('手机号格式错误')
      }

      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        mobile: this.mobile,
        originurl: window.location.origin + window.location.pathname,
        collegeName: '二级建造师',
        orign: '百度信息流',
        promotedAccount: '梓学教育吉re07-sl',
        remark: `报考时间：${this.provinces[this.provinceIndex]}`
      }).then(res => {
        window._agl && window._agl.push(['track', ['success', { t: 3 }]])
        this.$refs.successRef.open('平台升级，稍等为您转接人工客服，请注意接收查询结果')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.apply-date {
  .title {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    margin: 25px 0 15px;
    color: rgb(17, 67, 135);
    b {
      color: #d51719;
    }
  }
  .line {
    width: 740px;
    margin: 0 auto 30px;
    border-bottom: 1px solid rgb(231, 231, 231);
  }
  .content {
    width: 750px;
    width: 842px;
    margin: 0 auto;

    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 150px;
        display: block;
        line-height: 56px;
        height: 56px;
        border-radius: 3px;
        background-color: #efefef;
        font-size: 18px;
        color: #333333;
        text-align: center;
        margin-right: 23px;
        margin-bottom: 15px;
        cursor: pointer;
        &:nth-child(5n) {
          margin-right: 0;
        }
        &.on {
          color: #fff;
          background: rgb(17, 71, 143);
        }
      }
    }
    .submit-box {
      display: flex;
      align-items: center;
      margin-top: 30px;
      input {
        flex: 1;
        height: 50px;
        text-align: center;
        margin-right: 20px;
      }
      button {
        flex: 1;
        height: 50px;
        border: none;
        outline: none;
        color: #fff;
        cursor: pointer;
        background: rgb(17, 71, 143);
      }
    }
  }
  .choose {
    display: flex;
    justify-content: center;
    font-size: 18px;
    color: rgb(138, 138, 138);
    span {
      width: 140px;
      text-align: center;
      border-bottom: 1px solid rgb(15, 80, 154);
      color: rgb(15, 80, 154);
    }
  }
  .bottom-hint {
    margin-top: 20px;
    text-align: center;
    color: rgb(138, 138, 138);
    span {
      color: #d51719;
    }
  }
}
</style>
